import type { FC } from 'react'

export type TRoutePageType = {
  element: FC
  path: string
  title: string
  isPrivate?: boolean
}

export enum ERoutePaths {
  Home = '/',
  Category = '/category',
  Catalog = '/catalog',
  Information = '/information/:id',
  Wishlist = '/wishlist',
  Basket = '/basket',
  Cart = '/cart',
  Product = '/product/:id',
  OrderSuccess = '/order-success',
  Error = '*',
  Agreement = '/agreement',
}
